import { CancelReasonCode } from 'types/aaa'
import { useServiceProxy } from 'hooks/kong'
import { useUniversalCancelPayload } from '../universalPayload'
import { useTranslation } from 'react-i18next'
import { ProviderNames } from 'hooks/dispatch/utils'

type Props = {
  cancelReasonCode: CancelReasonCode
  cancellationText: string
  callKey: string
  provider: string
  service: any
}

export const useCancelDispatch = () => {
  const serviceProxy = useServiceProxy()
  const generateUniversalCancelPayload = useUniversalCancelPayload()
  const { t } = useTranslation()

  async function cancelDispatch({ cancelReasonCode, cancellationText, callKey, provider, service }: Props) {
    try {
      if (provider === ProviderNames.AAA) {
        return await serviceProxy(
          'DELETE',
          `/serviceproxy/aaa/dispatch/${callKey}`,
          {
            'Content-Type': 'application/json',
          },
          { cancelReasonCode, cancellationText },
        )
      }
      if (provider === ProviderNames.ALLSTATE) {
        const universalCancelPayload = await generateUniversalCancelPayload(service)
        return await serviceProxy('POST', '/serviceproxy/allstate/api/v1/create/em/dispatch', {}, universalCancelPayload)
      }
    } catch {
      console.error(`Unable to cancel ${provider.toLowerCase()} dispatch` || 'Unable to cancel dispatch')
      return t(`Unable to cancel ${provider.toLowerCase()} dispatch` || 'Unable to cancel dispatch')
    }
  }

  return cancelDispatch
}

export default useCancelDispatch
